var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffshore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96.77 96.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:rgba(255,255,255,.2);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.27,48.38c0,8.44-2.18,16.38-6.02,23.26-2.5,4.5-5.71,8.55-9.48,12.01-8.52,7.84-19.89,12.62-32.38,12.62s-23.87-4.78-32.39-12.62c-3.77-3.46-6.98-7.51-9.48-12.01-3.84-6.88-6.02-14.82-6.02-23.26s2.19-16.38,6.03-23.26c2.5-4.5,5.71-8.56,9.48-12.01C24.53,5.28,35.9,.5,48.39,.5s23.85,4.78,32.37,12.61c3.77,3.45,6.98,7.51,9.48,12.01,3.84,6.88,6.03,14.82,6.03,23.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.04,74.16c4.33-3.38,10.34-6.2,17.43-8.13h.01c.2-.06,.41-.11,.62-.16,6.65-1.75,14.24-2.75,22.29-2.75s15.64,1,22.29,2.76c.21,.05,.42,.1,.62,.16,7.09,1.93,13.1,4.74,17.43,8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.39,96.27c-13.22,0-23.94-21.44-23.94-47.88S35.16,.5,48.39,.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.39,.5c13.22,0,23.94,21.44,23.94,47.88s-10.72,47.88-23.94,47.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.99,86.18c3.36-1.31,7.07-2.4,11.07-3.23,.53-.11,1.07-.22,1.61-.31,5.2-.98,10.84-1.51,16.72-1.51s11.51,.53,16.72,1.51c.54,.09,1.08,.2,1.61,.31,3.99,.83,7.71,1.92,11.06,3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.04,22.61c4.33,3.38,10.34,6.2,17.43,8.13h.01c.2,.06,.41,.11,.62,.16,6.65,1.75,14.24,2.75,22.29,2.75s15.64-1,22.29-2.76c.21-.05,.42-.1,.62-.16,7.09-1.93,13.1-4.74,17.43-8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.99,10.59c3.36,1.31,7.07,2.4,11.07,3.23,.53,.11,1.07,.22,1.61,.31,5.2,.98,10.84,1.51,16.72,1.51s11.51-.53,16.72-1.51c.54-.09,1.08-.2,1.61-.31,3.99-.83,7.71-1.92,11.06-3.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 48.39,
    y1: 0.5,
    x2: 48.39,
    y2: 96.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 48.38,
    x2: 96.27,
    y2: 48.38
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffshore);
export default __webpack_public_path__ + "static/media/offshore.c6c4f14168411c28e4affdb486ff6070.svg";
export { ForwardRef as ReactComponent };